function getExtraOffset() {
	return window.innerWidth < 768 ? 65 : 50;
}

function getAbsoluteTop(el) {
	let top = 0;
	while (el) {
		top += el.offsetTop;
		el = el.offsetParent;
	}
	return top;
}

export function scrollToHashOnLoad() {
	if (!window.location.hash) return;
	const target = document.getElementById(window.location.hash.slice(1));
	if (!target) return;
	const header = document.querySelector('.site-header');
	const offset = header ? header.getBoundingClientRect().height : 0;
	const top = getAbsoluteTop(target) - offset - getExtraOffset();
	window.scrollTo({ top, behavior: 'instant' });
}

export function smoothScrollToAnchor(_sel) {
	_sel.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
			document.querySelector('.site-navigation__navicon').click();
		}

		if (e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__sub-menu')) {
			e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
		}

		if (e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__menu-item')) {
			e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
		}

		if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
			const target = document.getElementById(e.target.href.split('#')[ 1 ]);
			const header = document.querySelector('.site-header');
			const offset = header ? header.getBoundingClientRect().height : 0;
			const top = target.getBoundingClientRect().top + window.scrollY - offset - getExtraOffset();
			window.scrollTo({ top, behavior: 'smooth' });
		} else {
			window.location.href = e.target.href;
		}
	});
}
